module.exports = __webpack_public_path__ + "img/tar.95e09ffb.svg";